import "./Style/home.css";
import "./App.css";
import Home from "./Pages/Home";
import Register from "./Pages/Register";
import Forums from "./Pages/Forums";
import Open from "./Pages/Open";

import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import OpenNews from "./Components/OpenNews";
import OtherPages from "./Pages/OtherPages";
import OtherFPages from "./Pages/OtherFPages";
import Trending from "./Pages/Trending";
import New from "./Pages/New";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route>
          <Route path="/" element={<Home />} />
          <Route path="/forums/:id" element={<Forums />} />
          <Route path="/forums/:id/:idd" element={<OtherFPages />} />
          <Route path="/login" element={<Login />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/open/:id" element={<Open />} />
          <Route path="/trending" element={<Trending />} />
          <Route path="/new" element={<New />} />
          <Route path="/news/:id" element={<OtherPages />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
